'use strict';

/*@ngInject*/
module.exports = function ($rootScope, $location, $uibModal, classifiersService, publicObjectsService, systemIcons) {
    return {
        scope: {
            objectModalOpen: '=',
            viewMode: '=',
            objects: '=',
            mapObjects: '=',
            isScrollable: '=',
            isElectionObject: '<?',
            isSearching: '=',
            showExpandedFilter: '=',
            isCategoryFilterEmpty: '=',
            isMapView: '='
        },
        bindToController: true,
        controllerAs: 'vm',
        /*@ngInject*/
        controller: function controller($scope) {
            var restoreObjectsFilter = 'restoreObjectsFilter';
            var objectsFilter = 'objectsFilter';

            var vm = this;
            vm.objects = [];
            vm.mapObjects = [];
            vm.regionSelectionOpen = false;
            vm.isCategoryFilterEmpty = true;
            vm.objectsAmountForCategories = [];
            vm.filter = {
                groups: [],
                categories: [],
                subCategories: [],
                accessibilities: [],
                properties: [],
                addresses: [],
                isElectionObject: false
            };
            vm.systemIcons = systemIcons.features;

            $scope.$watch(function () {
                return vm.isMapView;
            }, function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    storeObjectFilterInLocalStorage();
                }
                if (vm.isMapView === false) {
                    vm.getObjects();
                }
            });

            $scope.$watch(function () {
                return angular.toJson(vm.filter.addresses);
            }, function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    vm.getAllObjectsBySearch();
                }
            });

            vm.rootScope = $rootScope;

            vm.groupsValueChange = function (val) {
                var idx = vm.filter.groups.indexOf(val);
                if (idx > -1) {
                    vm.filter.groups.splice(idx, 1);
                } else {
                    vm.filter.groups.push(val);
                }
                vm.getAllObjectsBySearch();
            };

            vm.categoryValueChange = function (val) {
                if (vm.showExpandedFilter) {
                    var idx = vm.filter.categories.indexOf(val);
                    if (idx > -1) {
                        angular.forEach(vm.objectCategories, function (category) {
                            if (category.id === val) {
                                if (category.subCategories) {
                                    angular.forEach(category.subCategories, function (subCategory) {
                                        if (vm.filter.subCategories.indexOf(subCategory.id) > -1) {
                                            vm.updateSubCategoryList(subCategory.id);
                                        }
                                    });
                                }
                            }
                        });
                        vm.filter.categories.splice(idx, 1);
                    } else {
                        vm.filter.categories.push(val);
                    }
                } else {
                    if (vm.filter.categories) {
                        var prevCat = vm.filter.categories[0];
                        vm.filter.categories = [];
                        vm.filter.subCategories = [];
                        if (val !== prevCat) {
                            vm.filter.categories.push(val);
                        }
                    } else {
                        vm.filter.categories.push(val);
                    }
                }
                vm.getAllObjectsBySearch();
                vm.isCategoryFilterEmpty = vm.filter.categories.length === 0;
            };

            vm.updateSubCategoryList = function (val) {
                var idx = vm.filter.subCategories.indexOf(val);
                if (idx > -1) {
                    vm.filter.subCategories.splice(idx, 1);
                } else {
                    vm.filter.subCategories.push(val);
                }
            };

            vm.subCategoryValueChange = function (val) {
                vm.updateSubCategoryList(val);
                vm.getAllObjectsBySearch();
            };

            vm.propertyValueChange = function (val) {
                if (vm.showExpandedFilter) {
                    var idx = vm.filter.properties.indexOf(val);
                    if (idx > -1) {
                        vm.filter.properties.splice(idx, 1);
                    } else {
                        vm.filter.properties.push(val);
                    }
                    vm.getAllObjectsBySearch();
                }
            };

            vm.accessibilityValueChange = function (val) {
                var idx = vm.filter.accessibilities.indexOf(val);
                if (idx > -1) {
                    vm.filter.accessibilities.splice(idx, 1);
                } else {
                    vm.filter.accessibilities.push(val);
                }
                vm.getAllObjectsBySearch();
            };

            vm.getAllObjectsBySearch = function () {
                vm.filter.limit = 50;
                vm.getMapObjects();
                if (vm.isMapView === false) {
                    vm.getObjects();
                }
            };

            vm.calcCategories = function () {
                publicObjectsService.objectsAmountForCategories(vm.getFilter()).then(function (response) {
                    var subCatAndCatList = response.data;
                    angular.forEach(vm.objectCategories, function (cat) {
                        cat.count = vm.getObjectsCountByCat(cat.id, subCatAndCatList.categories);
                        if (cat.subCategories) {
                            angular.forEach(cat.subCategories, function (subCat) {
                                subCat.count = vm.getObjectsCountByCat(subCat.id, subCatAndCatList.subCategories);
                            });
                        }
                    });
                });
            };

            vm.getObjects = function () {
                publicObjectsService.getObjectsBySearch(vm.getFilter(), null).then(function (result) {
                    vm.objects = result.data;
                });
            };

            vm.getMapObjects = function () {
                vm.isSearching = true;
                publicObjectsService.getMapObjectsBySearch(vm.getFilter(), null).then(function (result) {
                    vm.isSearching = false;
                    vm.mapObjects = result.data;
                });
            };

            vm.getFilter = function () {
                var filter = angular.copy(vm.filter);
                filter.isListView = true;

                storeObjectFilterInLocalStorage();

                if (vm.isElectionObject) {
                    filter.isElectionObject = true;
                }
                return filter;
            };

            vm.getObjectsCountByCat = function (catId, catList) {
                var count = 0;
                angular.forEach(catList, function (cat) {
                    if (cat.id === catId) {
                        count = cat.count;
                    }
                });
                return count;
            };

            function getItemsFromLocalStorage() {
                var filter = null;
                var restore = localStorage.getItem(restoreObjectsFilter);
                if (localStorage.getItem(objectsFilter) && restore && JSON.parse(restore) === true) {
                    filter = JSON.parse(localStorage.getItem(objectsFilter));
                } else {
                    localStorage.removeItem(objectsFilter);
                }
                localStorage.removeItem(restoreObjectsFilter);

                return filter;
            }

            function storeObjectFilterInLocalStorage() {
                vm.filter.isElectionObject = null;
                localStorage.setItem(objectsFilter, JSON.stringify({
                    isMapView: vm.isMapView,
                    filter: vm.filter
                }));
            }

            vm.$onInit = function () {
                var storedData = getItemsFromLocalStorage();
                if (storedData) {
                    vm.isMapView = storedData.isMapView;
                    vm.filter = storedData.filter;
                }

                if (vm.isElectionObject) {
                    vm.filter.isElectionObject = true;
                }
                vm.getAllObjectsBySearch();
                classifiersService.getObjectCategories().then(function (response) {
                    vm.objectCategories = response.data.objectCategories;
                    vm.calcCategories();

                    vm.groups = response.data.groups;
                    vm.accessibilityGroups = response.data.accessibilityGroups;
                    vm.groupedProperties = {};
                    var objectProperties = response.data.properties;
                    angular.forEach(vm.systemIcons, function (systemIcon, key) {
                        var properties = [];
                        angular.forEach(objectProperties, function (property) {
                            if (systemIcon.includes(property.icon_path)) {
                                properties.push(property);
                            }
                        });
                        vm.groupedProperties[key] = properties;
                    });
                });
            };
        },
        template: require('./object-search-filter.directive.html')
    };
};


/** WEBPACK FOOTER **
 ** ./app/shared/directives/object-search-filter.directive.js
 **/